export default __webpack_public_path__ + "static/media/2.cc436ce9.png";